import { getTranslationFile } from '@cx-modules/constants';
import { type Namespace, useTranslation } from '@cx-modules/i18n-provider';
import { mergePersistentParams } from '@cx-modules/utils';

import { AccordionText, StaticEventName } from '../../MatchesCoupon.style';

export default ({
  categoryGroupId,
  interactive = false,
  label,
  requestUrl,
  url,
}: {
  categoryGroupId: number;
  interactive?: boolean;
  label: string;
  requestUrl?: string;
  url?: string;
}) => {
  const ns = getTranslationFile(categoryGroupId);
  const { t } = useTranslation([(ns as Namespace) ?? 'label']);

  if (!interactive) {
    return <StaticEventName data-testid="event-name">{t(label, { ns })}</StaticEventName>;
  }

  return (
    <AccordionText data-testid="event-name" href={mergePersistentParams(url || '', requestUrl)} target="_blank">
      {t(label, { ns })}
    </AccordionText>
  );
};
